import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const fn = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  if (!show) return null;
  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 grid place-items-center w-11 h-11 rounded-full bg-ink-900 text-paper-50 hover:bg-coral-500 shadow-soft transition-colors"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </a>
  );
}